module.exports = __webpack_public_path__ + "img/link.4f6e7df6.svg";